export const FETCH_CAMPAIGNS = "FETCH_CAMPAIGNS"
export const SEARCH_CAMPAIGN = "SEARCH_CAMPAIGN"
export const FILTER_CAMPAIGN = "FILTER_CAMPAIGN"
export const GET_REPORT = "GET_REPORT";
export const SUCCESS = "SUCCESS";
export const SET_INITIAL = 'SET_INITIAL';
export const UPDATE_DONATION = 'UPDATE_DONATION';
export const CAPTURE_DONATION = 'CAPTURE_DONATION';
export const ALL_CAMPAIGNS = 'ALL_CAMPAIGNS';